import React, { Component } from 'react';
import * as services from '../projects/services';
import { Toast, Result, WhiteSpace, Icon } from 'antd-mobile';
import { CommonlyHead } from '../common/headnav';
import * as fun from '../../components/common';
import { PacksItems } from '../package/item';
import { createBrowserHistory } from "history";
const history = createBrowserHistory();
export default class AddCart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            params: this.props.match.params,
            data: [],
            result: 0,
            resultmess: '',
            bannerList: [],
        }
    }
    componentDidMount() {
        services.AddCart(this.state.params, '').then(data => {
            if (data.status === 0) {
                this.setState({ result: 1, resultmess: '购物车添加成功' });
                services.GetPackdetail(this.state.params.packId, '正在查询请稍后').then(value => {
                    if (value.status === 0) {
                        this.setState({ data: value.result });
                    } else {
                        Toast.offline(value.message);
                    }
                });
            } else {
                this.setState({ result: -1, resultmess: data.message });
                Toast.offline(data.message);
            }
        })
        //获取购物车广告位
        this.GetadvertisementList();
    }
    GetadvertisementList = () => {
        services.GetadvertisementList(global.advertisement.advertisement_wxcart, '').then(data => {
            if (data.status === 0) {
                this.setState({ bannerList: data.result });
            }
        });
    }
    //链接跳转
    openlink =(data,e) =>
    {
        if(!!data)
        {
            if(fun.IsWebsite(data.link) )
            {            
                window.location.href = fun.IsHttp(data.link);
            }else if(data.link !=='' && data.link !=='/')
            {
                history.push(data.link);
                history.go();
            }
        }
    }
    render() {
        const { data, result, resultmess } = this.state;
        const ResultExample = () => (<div className="result-example">
            <Result
                img={<Icon type="check-circle" className="spe" style={{ fill: '#32a128' }} />}
                title={resultmess}
            />
            <WhiteSpace />
        </div>);
        const ResultExample2 = () => (<div className="result-example">
            <Result
                img={<Icon type="cross-circle-o" className="spe" style={{ fill: '#F13642' }} />}
                title={resultmess}
            />
            <WhiteSpace />
        </div>);

        return <div className="shopping shoppingc">
            <CommonlyHead barname={'加入购物车'} />
            {
                result === 1 ? <ResultExample /> : ''
            }
            {
                result === -1 ? <ResultExample2 /> : ''
            }  {
                data.length === 0 ? '' : <PacksItems packData={data} key={1} type={'p'} />
            }
            <div className="butbox">
                <button className="buta" onClick={() => {
                    history.push('/package');
                    history.go();
                }}>继续购物</button>
                <button className="butb" onClick={() => {
                    history.push('/shopping');
                    history.go();
                }}>去购物车结算</button>
            </div>
            <div className="advertisementbox">
                {
                   this.state.bannerList.length > 0 ?
                   this.state.bannerList.map((data, index) => (
                        <div className="advertisement" key={index} >                            
                             <img alt={data.title}  src={data.picpath} onClick={this.openlink.bind(this,data)} />                       
                        </div>
                   ))
                       : ''
                }
            </div>

        </div>;
    }
}